module.exports = __webpack_public_path__ + "static/media/doar.9a7c1d3f.svg";